import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import SquareQty from '../../components/react-qty-square';

import './index.scss';

class QuantitySelectFilter extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {className = '', position, displayedQuantities = [], onFilterQuantitySelect} = this.props;

    const qtyOptions = displayedQuantities.map((value) => (
      <SquareQty
        displayedQty={value === 5 ? '5+' : value}
        key={`filterQty${value}`}
        onSelectedQty={(e) => onFilterQuantitySelect(e, value)}
        highlight={position === value}
      />
    ));

    return (
      <section className="ListingsFilter__sectionContainer">
        <h3 className="ListingsFilter__sectionContainer__Header">
          <FormattedMessage defaultMessage="Number of tickets" id="ListingsFilter.seatFeaturesHeader.numberOfTickets" />
        </h3>
        <ul className={`QuantitySelectFilter ${className}`}>{qtyOptions}</ul>
      </section>
    );
  }
}

QuantitySelectFilter.propTypes = {
  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,
  position: PropTypes.number,
  displayedQuantities: PropTypes.array,
  onFilterQuantitySelect: PropTypes.func.isRequired,
};

export default QuantitySelectFilter;
